import { Colors } from '@common/tokens';
import React from 'react';
import { Icon } from '@common/components';

export const TermsAndConditionsLink = () => (
  <div>
    <a
      className="account-settings__profile-menu-item__link"
      target="_blank"
      href="https://works.trustedhealth.com/legal"
      rel="noreferrer"
    >
      Terms and Conditions
      <Icon icon="arrowUpRightFromSquare" kind="light" size="md" />
    </a>
    <style jsx>{`
      .account-settings__profile-menu-item__link {
        padding: 8px 16px;
        font-size: 16px;
        color: ${Colors.textDefault};
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 24px;
      }

      .account-settings__profile-menu-item__link:hover {
        color: ${Colors.elm};
      }
    `}</style>
  </div>
);
